import { render } from "./VerifySchool.vue?vue&type=template&id=281e47f7&scoped=true"
import script from "./VerifySchool.vue?vue&type=script&lang=js"
export * from "./VerifySchool.vue?vue&type=script&lang=js"

import "./VerifySchool.vue?vue&type=style&index=0&id=281e47f7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-281e47f7"]])

export default __exports__